module.exports = __webpack_public_path__ + "media/images/e-learning-e446a4358e00a74d4db9816c76420063.png";